import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { DeviceDashboardTableData } from '@/types/operational-ui.types';
import { formatTimezoneShort } from '@/utils/formatters/timezoneFormatter';

export const DeviceDashboardLastConnectionTzCell = (
  _info: CellContext<DeviceDashboardTableData, string | undefined>
) => {
  const tz = _info.row.original.lastConnectionTz ?? 'UTC';
  return <span className="text-xs text-gray-600">{formatTimezoneShort(tz)}</span>;
};
